export const PRODUCT_DIMENSION_FORMATS = [
  { value: 'length_width_height', label: 'Length × Width × Height' },
  { value: 'diameter_height', label: 'Diameter × Height' },
  { value: 'diameter_thickness', label: 'Diameter × Thickness' },
  { value: 'length_width_thickness', label: 'Length × Width × Thickness' },
  { value: 'custom', label: 'Custom' },
];

export const formatProductDimension = (dim, fallbackUnit = 'mm') => {
  if (!dim) return '';
  if (typeof dim === 'string') return dim.trim();
  if (typeof dim !== 'object') return '';
  const unit = dim.unit || fallbackUnit || 'mm';
  const v = dim.values || {};
  const has = (x) => x !== null && x !== undefined && x !== '';
  const n = (x) => String(x);
  switch (dim.format) {
    case 'diameter_thickness':
      return has(v.diameter) && has(v.thickness) ? `${n(v.diameter)} ${unit} diameter × ${n(v.thickness)} ${unit} thickness` : '';
    case 'diameter_height':
      return has(v.diameter) && has(v.height) ? `${n(v.diameter)} ${unit} diameter × ${n(v.height)} ${unit} height` : '';
    case 'length_width_thickness':
      return has(v.length) && has(v.width) && has(v.thickness) ? `${n(v.length)} ${unit} length × ${n(v.width)} ${unit} width × ${n(v.thickness)} ${unit} thickness` : '';
    case 'length_width_height':
      return has(v.length) && has(v.width) && has(v.height) ? `${n(v.length)} × ${n(v.width)} × ${n(v.height)} ${unit}` : '';
    case 'custom':
      return String(dim.customText || '').trim();
    default:
      return '';
  }
};
